var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.005,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.892c2.8 0 3.134.013 4.243.063a5.729 5.729 0 011.95.363A3.258 3.258 0 0117.9 3.1a3.207 3.207 0 01.783 1.209 5.837 5.837 0 01.363 1.95c.05 1.109.063 1.438.063 4.243s-.013 3.134-.063 4.243a5.729 5.729 0 01-.363 1.95A3.258 3.258 0 0117.9 17.9a3.207 3.207 0 01-1.209.783 5.836 5.836 0 01-1.95.363c-1.109.05-1.438.063-4.243.063s-3.134-.013-4.243-.063a5.729 5.729 0 01-1.95-.363A3.258 3.258 0 013.1 17.9a3.207 3.207 0 01-.783-1.209 5.837 5.837 0 01-.363-1.95c-.054-1.105-.066-1.434-.066-4.241s.012-3.132.062-4.24a5.729 5.729 0 01.363-1.95A3.258 3.258 0 013.1 3.1a3.207 3.207 0 011.209-.783 5.837 5.837 0 011.95-.363c1.105-.054 1.434-.062 4.241-.062M10.5 0C7.649 0 7.291.013 6.17.063a7.7 7.7 0 00-2.546.488 5.117 5.117 0 00-1.861 1.212A5.207 5.207 0 00.55 3.622a7.7 7.7 0 00-.488 2.551C.013 7.289 0 7.647 0 10.5s.013 3.209.063 4.33a7.745 7.745 0 00.488 2.551 5.117 5.117 0 001.213 1.859 5.207 5.207 0 001.858 1.21 7.7 7.7 0 002.551.488c1.121.05 1.475.063 4.33.063s3.209-.013 4.33-.063a7.745 7.745 0 002.551-.488 5.117 5.117 0 001.859-1.213 5.207 5.207 0 001.213-1.859 7.7 7.7 0 00.488-2.551c.05-1.121.063-1.475.063-4.33s-.013-3.209-.063-4.33a7.745 7.745 0 00-.488-2.551 5.117 5.117 0 00-1.213-1.859A5.207 5.207 0 0017.384.544a7.7 7.7 0 00-2.551-.488C13.707.013 13.348 0 10.5 0z",
    "data-name": "Path 191",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.498 5.085a5.413 5.413 0 105.413 5.413 5.414 5.414 0 00-5.413-5.413zm0 8.926a3.514 3.514 0 113.514-3.514 3.513 3.513 0 01-3.514 3.514z",
    "data-name": "Path 192",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.254,
    cy: 1.254,
    "data-name": "Ellipse 114",
    transform: "translate(14.853 3.636)",
    fill: "#fff",
    r: 1.254
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.55cf114b.svg";
export { ForwardRef as ReactComponent };